import React from "react";
import { Box, Typography } from "@mui/material";
import { APP_COLORS } from "../../utils/constants";

export default function HeroSectionStyle({ id, title, p, colored }) {
  return (
    <Box
      id={id}
      className="container-fluid"
      sx={{
        color: colored ? APP_COLORS.BACKGROUND : APP_COLORS.FONT,
        backgroundColor: colored ? APP_COLORS.MAIN : "transparent",
      }}
    >
      <Box className="container">
        <Typography
          sx={{
            fontSize: { xs: "2rem", md: "5rem", lg: "8rem" },
            textAlign: { xs: "center", md: "left" },
            pt: { xs: "8rem", md: "18.5rem" },
            lineHeight: { xs: 1.2, md: 1 },
            fontWeight: { xs: 500, md: 400 },
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            maxWidth: "52rem",
            mt: 7.5,
            opacity: 0.9,
            fontSize: { xs: "1rem", lg: "1.4rem" },
            textAlign: { xs: "center", md: "left" },
            lineHeight: 1.2,
            fontWeight: 400,
            ml: 1,
          }}
        >
          {p}
        </Typography>
      </Box>
    </Box>
  );
}
